import { Box, TableCell, Tooltip } from '@mui/material';
import styles from './styles';

interface ConditionalTooltipProps {
  tooltipText?: string;
  children: React.ReactNode;
  isShortened?: boolean;
  isTableCell?: boolean;
}

/**
 * @param tooltipText if theres a string, then the tooltip will show it
 * @param children content to show
 * @param isShortened if true, then the content has a max width of 150
 * @param isTableCell if true, then the container will be a tablecell
 * @returns component with optional tooltip
 */
const ConditionalTooltip = ({
  tooltipText,
  children,
  isShortened = false,
  isTableCell = false,
}: ConditionalTooltipProps) => {
  const content = tooltipText ? (
    <Tooltip title={tooltipText} placement='top' arrow>
      <span>{children}</span>
    </Tooltip>
  ) : (
    children
  );

  if (isTableCell) {
    return <TableCell sx={isShortened ? styles.container : {}}>{content}</TableCell>;
  }

  return <Box sx={isShortened ? styles.container : {}}>{content}</Box>;
};

export default ConditionalTooltip;
